<template>
  <div class="price-panel">
    <!-- Static content -->
    <div class="price-panel__static">
      <h1 data-test-price-panel-title class="price-panel__title" v-html="headline" />
      <div class="price-panel__content flex-container flex-dir-column">
        <div
          :class="{ 'price-panel-total--no-actions': !$slots.actions }"
          class="price-panel-total flex-container flex-dir-column"
        >
          <div class="flex-container align-middle align-justify">
            <h3
              v-if="totalPriceLabel"
              class="price-panel-total__title"
              data-test-price-list-total-label
              v-html="totalPriceLabel"
            />
            <p class="price-panel-total__price" data-test-price-list-total>
              <span class="price-panel-total__price-number" v-html="totalPrice" />
              <span v-html="perYearLabel" />
            </p>
          </div>
        </div>
        <div v-if="$slots.actions" class="price-panel-actions" :class="actionsClass">
          <slot name="actions" />
        </div>
      </div>
    </div>

    <!-- Sticky bottom -->
    <div
      data-test-price-panel-sticky
      class="price-panel__sticky flex-container flex-dir-column align-justify"
    >
      <div class="flex-container align-middle align-justify">
        <h3 class="price-panel-total__title" v-html="totalPriceLabel" />
        <p class="price-panel-total__price">
          <span class="price-panel-total__price-number" v-html="totalPrice" />
          <span v-html="perYearLabel" />
        </p>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PricePanel',
  props: {
    headline: {
      type: String,
      default: () => ''
    },
    totalPriceLabel: {
      type: String,
      default: () => ''
    },
    totalPrice: {
      type: String,
      default: () => ''
    },
    perYearLabel: {
      type: String,
      default: () => ''
    },
    actionsClass: {
      type: String,
      default: () => ''
    }
  },
  mounted() {
    window.addEventListener('scroll', () => this.recalculate());
    window.addEventListener('resize', () => this.recalculate());
    window.addEventListener('load', () => this.recalculate());
    this.recalculate();
  },
  methods: {
    recalculate() {
      const stickyEl = $('.price-panel__sticky');
      const staticElement = $('.price-panel-total');
      const elementOffset = staticElement.offset();
      const elementTop = elementOffset?.top || 0;
      const elementBottom = elementTop + (staticElement?.outerHeight() || 0);

      const windowHeight = window.innerHeight;
      const windowScrollTop = window.scrollY;
      const windowScroll = windowScrollTop + windowHeight;

      const stickyHideClass = 'price-panel__sticky--hide';
      if (windowScroll >= elementBottom - 1) stickyEl.addClass(stickyHideClass);
      else stickyEl.removeClass(stickyHideClass);
    }
  }
});
</script>
<style lang="scss" scoped>
@import 'src/styles/all.scss';

.price-panel {
  &__static {
    height: fit-content;
    width: 100%;
    background: $body-background;
    border-radius: rem-calc(15) rem-calc(15) 0 0;

    @include breakpoint(large up) {
      padding: rem-calc(8);
    }
  }

  &__title {
    margin: 0;
    text-align: center;

    @include breakpoint(medium down) {
      display: none;
    }
  }

  &__content {
    width: 100%;
    height: 100%;

    @include breakpoint(large up) {
      background: #ffffff;
      border: 1px solid $medium-gray;
    }
  }

  &__sticky {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: rem-calc(15) rem-calc(15) 0 0;
    background: $body-background;
    z-index: 20;

    @include breakpoint(medium down) {
      padding: rem-calc(20) rem-calc(40);
    }

    @include breakpoint(large up) {
      display: none;
    }

    &--hide {
      display: none;
    }
  }
}

.price-panel-total {
  @include breakpoint(large up) {
    padding: rem-calc(20) rem-calc(30);
  }

  @include breakpoint(medium down) {
    padding: rem-calc(20) rem-calc(40);

    &--no-actions {
      padding-bottom: rem-calc(20);
    }
  }

  &__title {
    margin-bottom: 0;
  }

  &__price {
    font-weight: 700;
    font-size: rem-calc(14);
    margin-bottom: rem-calc(4);

    &-number {
      font-size: rem-calc(25);
      margin-right: rem-calc(4);

      @include breakpoint(medium down) {
        font-size: rem-calc(20);
      }
    }
  }
}

.price-panel-actions {
  @include breakpoint(medium down) {
    padding: 0 rem-calc(20) 0;
  }

  @include breakpoint(large up) {
    border-top: 1px solid $medium-gray;
    padding: rem-calc(20) rem-calc(30) 0;
  }
}
</style>
